export default {
  path: '/employees',
  component: () => import('@/views/employees/Index'),
  redirect: { name: 'employees-list' },
  children: [
    {
      path: 'employees',
      component: () => import('@/views/employees/employees/Index'),
      children: [
        {
          path: '',
          name: 'employees-list',
          component: () => import('@/views/employees/employees/List'),
          meta: {
            title: 'List of employees',
            roles: ['general_manager', 'hr_manager', 'hr_supervisor']
          }
        },
        {
          path: ':id',
          component: () => import('@/views/employees/employees/detail/Layout'),
          children: [
            {
              path: '',
              name: 'employees-profile',
              component: () => import('@/views/employees/employees/detail/Profile'),
              meta: {
                title: 'Employee profile',
                roles: ['general_manager', 'hr_manager', 'hr_supervisor']
              }
            },
            {
              path: 'documents',
              name: 'employees-documents',
              component: () => import('@/views/employees/employees/detail/Documents'),
              meta: {
                title: 'Employee documents',
                roles: ['general_manager', 'hr_manager', 'hr_supervisor']
              }
            },
            {
              path: 'contracts-salaries',
              name: 'employees-contracts-salaries',
              component: () => import('@/views/employees/employees/detail/ContractsSalaries'),
              meta: {
                title: 'Employee contracts & salaries',
                roles: ['general_manager', 'hr_manager', 'hr_supervisor']
              }
            },
            {
              path: 'leaves',
              name: 'employees-employee-leaves',
              component: () => import('@/views/employees/employees/detail/Leaves'),
              meta: {
                title: 'Employee leaves',
                roles: ['general_manager', 'hr_manager', 'hr_supervisor']
              }
            },
            {
              path: 'other',
              name: 'employees-other',
              component: () => import('@/views/employees/employees/detail/Other'),
              meta: {
                title: 'Other',
                roles: ['general_manager', 'hr_manager', 'hr_supervisor']
              }
            },
            {
              path: 'biometry',
              name: 'employees-biometry',
              component: () => import('@/views/employees/employees/detail/Biometry'),
              meta: {
                title: 'Biometry',
                roles: ['general_manager', 'hr_manager', 'hr_supervisor']
              }
            },
            {
              path: 'calculation',
              name: 'employees-calculation',
              component: () => import('@/views/employees/employees/detail/Calculation'),
              meta: {
                title: 'Calculation',
                roles: ['general_manager', 'hr_manager', 'hr_supervisor']
              }
            },
            {
              path: 'comments',
              name: 'employees-comments',
              component: () => import('@/views/employees/employees/detail/Comments'),
              meta: {
                title: 'Comments',
                roles: ['general_manager', 'hr_manager', 'hr_supervisor']
              }
            },
            {
              path: 'utt',
              name: 'employees-utt',
              component: () => import('@/views/employees/employees/detail/UTT'),
              meta: {
                title: 'UTT',
                roles: ['general_manager']
              }
            },
          ]
        },
      ]
    },
    {
      path: 'warnings',
      component: () => import('@/views/employees/warnings/Index'),
      children: [
        {
          path: '',
          name: 'employees-warnings',
          component: () => import('@/views/employees/warnings/List'),
          meta: {
            title: 'Warnings',
            roles: ['general_manager', 'hr_manager', 'hr_supervisor']
          }
        },
      ]
    },
    {
      path: 'heslb-loans',
      component: () => import('@/views/employees/heslb-loans/Layout'),
      children: [
        {
          path: '',
          name: 'employees-heslb-loans',
          component: () => import('@/views/employees/heslb-loans/Active'),
          meta: {
            title: 'HESLB Loans',
            roles: ['general_manager', 'hr_manager', 'hr_supervisor', 'accountant_supervisor', 'accountant_manager']
          }
        },
        {
          path: 'fully-paid',
          name: 'employees-heslb-loans-paid',
          component: () => import('@/views/employees/heslb-loans/Paid'),
          meta: {
            title: 'HESLB Loans',
            roles: ['general_manager', 'hr_manager', 'hr_supervisor', 'accountant_supervisor', 'accountant_manager']
          }
        },
        {
          path: 'inactive',
          name: 'employees-heslb-loans-inactive',
          component: () => import('@/views/employees/heslb-loans/Inactive'),
          meta: {
            title: 'HESLB Loans',
            roles: ['general_manager', 'hr_manager', 'hr_supervisor', 'accountant_supervisor', 'accountant_manager']
          }
        },
      ]
    },
    {
      path: 'staff-loans',
      component: () => import('@/views/employees/staff-loans/Layout'),
      children: [
        {
          path: '',
          name: 'employees-staff-loans',
          component: () => import('@/views/employees/staff-loans/Requests'),
          meta: {
            title: 'Staff Loans',
            roles: ['general_manager', 'hr_manager', 'hr_supervisor', 'accountant_supervisor', 'accountant_manager']
          }
        },
        {
          path: 'fully-paid',
          name: 'employees-staff-loans-active',
          component: () => import('@/views/employees/staff-loans/Active'),
          meta: {
            title: 'Staff Loans',
            roles: ['general_manager', 'hr_manager', 'hr_supervisor', 'accountant_supervisor', 'accountant_manager']
          }
        },
        {
          path: 'archive',
          name: 'employees-staff-loans-archive',
          component: () => import('@/views/employees/staff-loans/Archive'),
          meta: {
            title: 'Staff Loans',
            roles: ['general_manager', 'hr_manager', 'hr_supervisor', 'accountant_supervisor', 'accountant_manager']
          }
        },
      ]
    },
    {
      path: 'advances',
      component: () => import('@/views/employees/advances/Layout'),
      children: [
        {
          path: '',
          name: 'employees-advances',
          component: () => import('@/views/employees/advances/Requests'),
          meta: {
            title: 'Advances',
            roles: ['general_manager', 'hr_manager', 'hr_supervisor', 'accountant_supervisor', 'accountant_manager']
          }
        },
        {
          path: 'disbursed',
          name: 'employees-advances-disbursed',
          component: () => import('@/views/employees/advances/Requests'),
          meta: {
            title: 'Advances',
            roles: ['general_manager', 'hr_manager', 'hr_supervisor', 'accountant_supervisor', 'accountant_manager']
          }
        },
        {
          path: 'rejected',
          name: 'employees-advances-rejected',
          component: () => import('@/views/employees/advances/Requests'),
          meta: {
            title: 'Advances',
            roles: ['general_manager', 'hr_manager', 'hr_supervisor', 'accountant_supervisor', 'accountant_manager']
          }
        },
        {
          path: 'archive',
          name: 'employees-advances-archive',
          component: () => import('@/views/employees/advances/Requests'),
          meta: {
            title: 'Advances',
            roles: ['general_manager', 'hr_manager', 'hr_supervisor', 'accountant_supervisor', 'accountant_manager']
          }
        },
      ]
    },
    {
      path: 'payroll',
      component: () => import('@/views/employees/payroll/Index'),
      children: [
        {
          path: '',
          name: 'employees-payroll-list',
          component: () => import('@/views/employees/payroll/List'),
          meta: {
            title: 'Payrolls',
            roles: ['general_manager', 'hr_manager', 'hr_supervisor', 'accountant_supervisor', 'accountant_manager']
          }
        },
        {
          path: ':id',
          component: () => import('@/views/employees/payroll/Layout'),
          children: [
            {
              path: '',
              name: 'employees-payroll-employees',
              component: () => import('@/views/employees/payroll/Employees'),
              meta: {
                title: 'Payroll',
                roles: ['general_manager', 'hr_manager', 'hr_supervisor', 'accountant_supervisor', 'accountant_manager']
              }
            },
            {
              path: 'downloads',
              name: 'employees-payroll-downloads',
              component: () => import('@/views/employees/payroll/Downloads'),
              meta: {
                title: 'Downloads',
                roles: ['general_manager', 'hr_manager', 'hr_supervisor', 'accountant_supervisor', 'accountant_manager']
              }
            },
            {
              path: 'taxes',
              name: 'employees-payroll-taxes',
              component: () => import('@/views/employees/payroll/Taxes'),
              meta: {
                title: 'Taxes',
                roles: ['general_manager', 'hr_manager', 'hr_supervisor', 'accountant_supervisor', 'accountant_manager']
              }
            },
          ]
        }
      ]
    },
    {
      path: 'utt-balance',
      name: 'employees-utt-balance',
      component: () => import('@/views/employees/UTTBalance'),
      meta: {
        title: 'UTT Balance',
        roles: ['general_manager']
      }
    },
    {
      path: 'contract-renewals',
      name: 'employees-contract-renewals',
      component: () => import('@/views/employees/ContractRenewals'),
      meta: {
        title: 'Contract renewals',
        roles: ['general_manager', 'hr_manager', 'hr_supervisor']
      }
    },
    {
      path: 'feedback',
      name: 'employees-feedback',
      component: () => import('@/views/employees/feedback/EmployeeFeedback'),
      meta: {
        title: 'Employee Feedback',
        roles: ['general_manager']
      }
    },
    {
      path: 'misconduct',
      name: 'employees-misconduct',
      component: () => import('@/views/employees/feedback/Misconduct'),
      meta: {
        title: 'Misconduct',
        roles: ['general_manager']
      }
    },
    {
      path: 'dashboard',
      name: 'employees-dashboard',
      component: () => import('@/views/employees/Dashboard'),
      meta: {
        title: 'Employee dashboard',
        roles: ['general_manager', 'hr_manager', 'hr_supervisor']
      }
    },
    {
      path: 'employees-sales-work-schedule',
      name: 'sales-work-schedule',
      component: () => import('@/views/employees/sales-work-schedule/Index'),
      meta: {
        title: 'Sales Work Schedule',
        roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'marketing_supervisor', 'safari_supervisor']
      }
    },
    {
      path: 'shift-planner',
      name: 'employees-shift-planner',
      component: () => import('@/views/employees/shift-planner/Planner'),
      meta: {
        title: 'Sales Shift Planner',
        roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'marketing_supervisor']
      }
    },
    {
      path: 'shift-planner-dashboard',
      name: 'employees-shift-planner-dashboard',
      component: () => import('@/views/employees/shift-planner/Dashboard'),
      meta: {
        title: 'Shift Planner Dashboard',
        roles: ['general_manager', 'sales_supervisor', 'marketing_supervisor']
      }
    },
    {
      path: 'leaves',
      component: () => import('@/views/employees/leaves/Layout'),
      children: [
        {
          path: '',
          name: 'employees-leaves',
          component: () => import('@/views/employees/leaves/Requests'),
          beforeEnter: (to, from, next) => {
            const roles = JSON.parse(localStorage.getItem('userGroups')) || []
            const canViewRequests = roles.some(role => ['hr_manager', 'hr_supervisor', 'general_manager'].includes(role.code))

            if (canViewRequests) next()
            else next({ name: 'employees-leaves-schedule' })
          },
          meta: {
            title: 'Employee leaves',
            roles: ['general_manager', 'hr_manager', 'hr_supervisor']
          }
        },
        {
          path: 'schedule',
          name: 'employees-leaves-schedule',
          component: () => import('@/views/employees/leaves/Schedule.vue'),
          meta: {
            title: 'Employee leaves',
            roles: ['general_manager', 'hr_manager', 'hr_supervisor']
          }
        },
        {
          path: 'list',
          name: 'employees-leaves-list',
          component: () => import('@/views/employees/leaves/Leaves.vue'),
          meta: {
            title: 'Employee leaves',
            roles: ['general_manager', 'hr_manager', 'hr_supervisor']
          }
        },
      ]
    },
    {
      path: 'sales-leaves',
      component: () => import('@/views/employees/leaves-old/Layout'),
      children: [
        {
          path: '',
          name: 'employees-sales-leaves',
          component: () => import('@/views/employees/sales-leave/Workspace'),
          meta: {
            title: 'Leave (Sales)',
            leaveScope: 'sales',
            roles: ['general_manager', 'sales_supervisor', 'marketing_supervisor']
          }
        },
        {
          path: 'schedule',
          name: 'employees-sales-leaves-schedule',
          component: () => import('@/views/employees/leaves-old/Schedule.vue'),
          meta: {
            title: 'Leave (Sales)',
            leaveScope: 'sales',
            roles: ['general_manager', 'sales_supervisor', 'marketing_supervisor']
          }
        },
        {
          path: 'list',
          name: 'employees-sales-leaves-list',
          component: () => import('@/views/employees/sales-leave/Workspace'),
          meta: {
            title: 'Leave (Sales)',
            leaveScope: 'sales',
            roles: ['general_manager', 'sales_supervisor', 'marketing_supervisor']
          }
        },
      ]
    },
    {
      path: 'analytics',
      component: () => import('@/views/employees/analytics/Layout'),
      children: [
        {
          path: '',
          name: 'employees-analytics',
          component: () => import('@/views/employees/analytics/Summary'),
          meta: {
            title: 'Employee analytics',
            roles: ['general_manager']
          }
        },
        {
          path: 'compensation',
          name: 'employees-analytics-compensation',
          component: () => import('@/views/employees/analytics/Compensation'),
          meta: {
            title: 'Employee analytics',
            roles: ['general_manager']
          }
        }
      ]
    }
  ]
}
